"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createStyles = _interopRequireDefault(require("@material-ui/core/styles/createStyles"));
var _makeStyles = _interopRequireDefault(require("@material-ui/core/styles/makeStyles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var styles = (0, _makeStyles.default)(theme => (0, _createStyles.default)({
  root: {
    margin: theme.spacing(2, 0),
    paddingLeft: theme.spacing(3),
    height: '100%',
    width: '100%',
    maxWidth: '750px',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(1)
    }
  },
  calloutBox: {
    backgroundColor: theme.palette.custom.blue.light,
    width: '100%',
    padding: theme.spacing(2),
    borderLeft: "4px solid ".concat(theme.palette.primary.main),
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start'
  },
  calloutTextIcon: {
    color: theme.palette.primary.main
  },
  calloutTextSpacing: {
    marginLeft: theme.spacing(2)
  }
}), {
  name: 'Callout'
});
var _default = exports.default = styles;